<template>
  <v-dialog v-model="navigation.CRMWhatsappContactFileDialogIsVisible" @update:model-value="navigation.CRMWhatsappContactFileDialogIsVisible == false ? closeCRMWhatsappContactFileDialog() : null" :persistent="loader.generalLoader" max-width="40vw">
    <v-card max-width="40vw">
      <div v-if="loader.generalLoader" style="display: flex; justify-content: center; align-items: center; width: 100%; padding: 10px 0px;">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <div v-if="navigation.CRMWhatsappContactFileDialogAction == 'delete'">
          <v-alert type="error" variant="tonal" style="cursor: default; user-select: none;">
            <template v-slot:title>
              <h3>ATENCIÓN</h3>
            </template>
            <p style="margin-top: 5px;">El archivo del contacto <strong>{{ navigation.CRMWhatsappContactFile.CRMWhatsappContactFileName }}</strong> será eliminado</p>
            <p>Esta acción es irreversible</p>
            <v-checkbox v-model="input.deleteCRMWhatsappContactFileConfirmation" color="error" label="Estoy de acuerdo" hide-details></v-checkbox>
            <v-btn @click="deleteCRMWhatsappContactFile()" :disabled="!input.deleteCRMWhatsappContactFileConfirmation" color="error" dark block height="38" style="margin-top: 15px;">
              <h3>ELIMINAR ARCHIVO DEL CONTACTO</h3>
              <v-icon style="margin-left: 10px;" dark right>mdi-delete</v-icon>
            </v-btn>
            <v-btn @click="closeCRMWhatsappContactFileDialog()" color="primary" dark block height="38" style="margin-top: 15px;">
              <h3>CANCELAR</h3>
              <v-icon style="margin-left: 10px;" dark right>mdi-close-circle</v-icon>
            </v-btn>
          </v-alert>
        </div>
        <div v-else style="padding: 15px;">
          <v-text-field 
            ref="CRMWhatsappContactFileName"
            v-model="input.CRMWhatsappContactFileName" 
            :append-inner-icon="input.CRMWhatsappContactFileName && /\S/.test(input.CRMWhatsappContactFileName) ? 'mdi-alphabetical-variant-off' : 'mdi-alphabetical-variant'" 
            @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFileName'); input.CRMWhatsappContactFileName = null" 
            label="Nombre del archivo del contacto" 
            variant="solo-filled" 
            density="compact"
            autocomplete="off"
            hide-details
            style="margin-bottom: 10px;"
          ></v-text-field>
          <v-textarea 
            ref="CRMWhatsappContactFileDescription"
            v-model="input.CRMWhatsappContactFileDescription" 
            :append-inner-icon="input.CRMWhatsappContactFileDescription && /\S/.test(input.CRMWhatsappContactFileDescription) ? 'mdi-alphabetical-off' : 'mdi-alphabetical'" 
            @click:append-inner="$generalFunctions.default.blurInput(this, 'CRMWhatsappContactFileDescription'); input.CRMWhatsappContactFileDescription = null" 
            label="Descripción del archivo del contacto (opcional)" 
            variant="solo-filled" 
            density="compact"
            autocomplete="off"
            rows="3"
            max-rows="5"
            auto-grow
            hide-details
            style="margin-bottom: 20px;"
          ></v-textarea>
          <div style="display: flex; align-items: center; justify-content: center; width: 100%; margin-bottom: 20px;">
            <img :src="input.CRMWhatsappContactFileURL" draggable="false" style="height: 300px; width: auto;">
          </div>
          <v-tooltip :disabled="validateInputForCRMWhatsappContactFileDialog(false).success" location="top"> 
            <template v-slot:activator="{ props }">
              <div v-bind="props">
                <v-btn @click="navigation.CRMWhatsappContactFileDialogAction == 'insert' ? insertCRMWhatsappContactFile() : updateCRMWhatsappContactFile()" :disabled="!validateInputForCRMWhatsappContactFileDialog(false).success" :color="navigation.CRMWhatsappContactFileDialogAction == 'insert' ? 'success' : 'warning'" dark block height="38" style="margin-bottom: 10px;">
                  <h3>{{ navigation.CRMWhatsappContactFileDialogAction == 'insert' ? 'AGREGAR' : 'ACTUALIZAR' }} ARCHIVO DEL CONTACTO</h3>
                  <v-icon style="margin-left: 10px;" dark right>{{ navigation.CRMWhatsappContactFileDialogAction == 'insert' ? 'mdi-plus-circle' : 'mdi-pencil' }}</v-icon>
                </v-btn>
              </div>
            </template>
            <span style="max-width: 400px; display: block;">{{ validateInputForCRMWhatsappContactFileDialog(false).result }}</span>
          </v-tooltip>
          <v-btn @click="closeCRMWhatsappContactFileDialog()" color="error" dark block height="38">
            <h3>CANCELAR</h3>
            <v-icon style="margin-left: 10px;" dark right>mdi-close-circle</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => 
    ({
      input: 
      {
        CRMWhatsappContactFileName: null,
        CRMWhatsappContactFileDescription: null,
        CRMWhatsappContactFileURL: null,
        deleteCRMWhatsappContactFileConfirmation: false
      },
      navigation: 
      {
        CRMWhatsappContactFileDialogIsVisible: false,
        CRMWhatsappContactID: null,
        CRMWhatsappContactFile: null,
        CRMWhatsappContactFileDialogAction: null
      },
      loader: 
      {
        generalLoader: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    methods:
    {

      async insertCRMWhatsappContactFile(){
        if (this.validateInputForCRMWhatsappContactFileDialog(true).success){
          this.loader.generalLoader = true;
          const insertCRMWhatsappContactFileRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID,
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
            'CRMWhatsappContactFileName': this.input.CRMWhatsappContactFileName,
            'CRMWhatsappContactFileDescription': this.input.CRMWhatsappContactFileDescription,
            'CRMWhatsappContactFileURL': this.input.CRMWhatsappContactFileURL
          };
          const insertCRMWhatsappContactFileResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFile/functions/insertCRMWhatsappContactFileFromCRMWhatsappContactFileDialog', insertCRMWhatsappContactFileRequestQuery);
          if (insertCRMWhatsappContactFileResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContactFile_success', 'success', `El archivo ${this.input.CRMWhatsappContactFileName} del contacto ha sido agregado`, null, true);
            this.closeCRMWhatsappContactFileDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog(insertCRMWhatsappContactFileResult.result, 'error', `Ha ocurrido un error inesperado al agregar el archivo ${this.input.CRMWhatsappContactFileName} del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },

      async updateCRMWhatsappContactFile(){
        if (this.validateInputForCRMWhatsappContactFileDialog(true).success){
          this.loader.generalLoader = true;
          const updateCRMWhatsappContactFileRequestQuery = 
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID,
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
            'CRMWhatsappContactFileID': this.navigation.CRMWhatsappContactFile.CRMWhatsappContactFileID,
            'CRMWhatsappContactFileName': this.input.CRMWhatsappContactFileName,
            'CRMWhatsappContactFileDescription': this.input.CRMWhatsappContactFileDescription
          };
          const updateCRMWhatsappContactFileResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFile/functions/updateCRMWhatsappContactFileFromCRMWhatsappContactFileDialog', updateCRMWhatsappContactFileRequestQuery);
          if (updateCRMWhatsappContactFileResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactFile_success', 'success', `El archivo ${this.input.CRMWhatsappContactFileName} del contacto ha sido actualizado`, null, true);
            this.closeCRMWhatsappContactFileDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog(updateCRMWhatsappContactFileResult.result, 'error', `Ha ocurrido un error inesperado al actualizar el archivo ${this.input.CRMWhatsappContactFileName} del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },

      async deleteCRMWhatsappContactFile(){
        this.loader.generalLoader = true;
        const deleteCRMWhatsappContactFileRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID,
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
          'CRMWhatsappContactFileID': this.navigation.CRMWhatsappContactFile.CRMWhatsappContactFileID
        };
        const deleteCRMWhatsappContactFileResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContact/CRMWhatsappContactFile/functions/deleteCRMWhatsappContactFileFromCRMWhatsappContactFileDialog', deleteCRMWhatsappContactFileRequestQuery);
        if (deleteCRMWhatsappContactFileResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContactFile_success', 'success', `El archivo ${this.input.CRMWhatsappContactFileName} del contacto ha sido eliminado`, null, true);
          this.closeCRMWhatsappContactFileDialog();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog(deleteCRMWhatsappContactFileResult.result, 'error', `Ha ocurrido un error inesperado al eliminar el archivo ${this.input.CRMWhatsappContactFileName} del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.generalLoader = false;
      },

      validateInputForCRMWhatsappContactFileDialog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.input.CRMWhatsappContactFileName == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactFileName)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactFileDialog_CRMWhatsappContactFileName', 'warning', 'El nombre del archivo del contacto es obligatorio', null, true);
          return {success: false, result: 'El nombre del archivo del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactFileName.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactFileDialog_CRMWhatsappContactFileName', 'warning', 'El nombre del archivo del contacto no puede exceder los 100 caracteres de longitud', null, true);
          return {success: false, result: 'El nombre del archivo del contacto no puede exceder los 100 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactFileDescription != null && this.input.CRMWhatsappContactFileDescription.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactFileDialog_CRMWhatsappContactFileDescription', 'warning', 'La descripción del archivo del contacto no puede exceder los 65535 caracteres de longitud', null, true);
          return {success: false, result: 'La descripción del archivo del contacto no puede exceder los 65535 caracteres de longitud'};
        }
        return {success: true, result: null};
      },


      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            if (!this.systemInformationData.updateSubscription){
              this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
                this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
              });
            }          
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('closeCRMWhatsappConversationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      async openCRMWhatsappContactFileDialog(CRMWhatsappContactID, CRMWhatsappContactFile, CRMWhatsappContactFileDialogAction){
        await this.getSystemInformationData();
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.navigation.CRMWhatsappContactFile = JSON.parse(JSON.stringify(CRMWhatsappContactFile));
        this.navigation.CRMWhatsappContactFileDialogAction = CRMWhatsappContactFileDialogAction;
        this.input.CRMWhatsappContactFileName = CRMWhatsappContactFile ? CRMWhatsappContactFile.CRMWhatsappContactFileName : null;
        this.input.CRMWhatsappContactFileDescription = CRMWhatsappContactFile ? CRMWhatsappContactFile.CRMWhatsappContactFileDescription : null;
        this.input.CRMWhatsappContactFileURL = CRMWhatsappContactFile ? CRMWhatsappContactFile.CRMWhatsappContactFileURL : null;
        this.input.deleteCRMWhatsappContactFileConfirmation = false;
        this.navigation.CRMWhatsappContactFileDialogAction != 'delete' && this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactFileName');
        this.navigation.CRMWhatsappContactFileDialogIsVisible = true;
      },

      closeCRMWhatsappContactFileDialog(){
        this.navigation.CRMWhatsappContactFileDialogIsVisible = false;
        this.$emit('closeCRMWhatsappContactFileDialog');
      }
    }
  }
</script>